module.exports = __webpack_public_path__ + "img/calendar_on.55f4726c.svg";